// Purpose: render button elements for popup forms
define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'es6!launcher/util/listbuilder/constants',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, Constants, Component) => {
  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'lineHeight',
    'textShadow',
  ];

  const { FormTypes } = Constants;

  @Component()
  class Discount extends React.Component {
    static propTypes = {
      text: PropTypes.string,
      style: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    };

    constructor(props) {
      super(props);

      this.state = {
        copied: false,
      };

      this.onClick = this.onClick.bind(this);
      this.resetCopiedState = this.resetCopiedState.bind(this);
    }

    onClick(event) {
      const { discountCode, copyToClipboard } = this.props;
      event.preventDefault();

      if (!copyToClipboard) return false;

      /* Create textarea to copy text from
       * document.body causes issues on iOS, fall to document.body for good measure
       * select() doesn't work on iOS, use focus() -> setSelectionRange()
       */
      if (discountCode) {
        const formElem = document.querySelector('.listbuilder-popup-scale') || document.body;
        let textarea = document.createElement('TEXTAREA');
        textarea.setAttribute('style', 'visibility: none; height: 100%; width: 100%;');
        textarea.value = discountCode;
        formElem.appendChild(textarea);
        textarea.focus();
        textarea.setSelectionRange(0, 9999);
        document.execCommand('copy');
        formElem.removeChild(textarea);
        textarea = null;
      }

      // Copy to clipboard and replace text
      this.setState({ copied: true });
    }

    resetCopiedState() {
      this.setState({ copied: false });
    }

    render() {
      const {
        text,
        formType,
        action,
        boxShadowStyle,
        onMouseEnter,
        onMouseLeave,
        isPreview,
        discountCode,
        copiedText,
      } = this.props;
      const { copied } = this.state;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);
      const sizingStyle = {
        padding: '0',
        margin: '0',
        display: 'block',
        width: '100%',
        height: '100%'
      };

      _.extend(style, sizingStyle, {
        boxShadow: boxShadowStyle.insetBoxShadow,
        cursor: isPreview ? null : 'pointer',
      });

      const containerStyle = _.extend(sizingStyle, {
        position: 'relative',
        overflow: 'hidden',
        zIndex: 0,
        boxShadow: boxShadowStyle.boxShadow,
      }, _.pick(
        this.props.style.toJS(),
        'borderColor',
        'borderStyle',
        'borderTopLeftRadius',
        'borderTopRightRadius',
        'borderBottomLeftRadius',
        'borderBottomRightRadius',
        'borderTopWidth',
        'borderLeftWidth',
        'borderBottomWidth',
        'borderRightWidth',
      ));

      if (!isPreview && !discountCode) {
        // Don't show discount code component if there isn't a discount code.
        return null;
      }

      let label = discountCode || text;
      if (copied && !isPreview) {
        label = copiedText;

        if (!this.refreshTimeout) {
          this.refreshTimeout = setTimeout(() => {
            this.resetCopiedState();
            this.refreshTimeout = null;
          }, 2500);
        }
      }

      return (
        <div
          style={containerStyle}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <button style={style} onClick={this.onClick}>{label}</button>
        </div>
      );
    }
  }

  return Discount;
});
